// @ts-nocheck
import { OptionObject } from "@insite/mobius/DynamicDropdown";
import { useEffect, useState } from "react";

interface ApproverModel {
    Id: string;
    FirstName: string;
    LastName: string;
    Username: string;
}

const useApprovers = (cart?: { properties?: { availableApprovers?: string } }) => {
    const [approverId, setApproverId] = useState("");
    const [options, setOptions] = useState<OptionObject[]>([]);

    useEffect(() => {
        if (cart?.properties?.availableApprovers) {
            const availableApprovers: ApproverModel[] = JSON.parse(cart.properties.availableApprovers || "[]");

            const mappedOptions: OptionObject[] = availableApprovers.map(approver => ({
                optionText:
                    approver.FirstName && approver.LastName
                        ? `${approver.FirstName} ${approver.LastName}`
                        : approver.Username,
                optionValue: approver.Id,
            }));

            setOptions(mappedOptions);
        }
    }, [cart]);

    const selectApproverHandler = (selectedApproverId?: string) => {
        setApproverId(selectedApproverId ?? "");
    };

    return { approverId, options, selectApproverHandler };
};

export default useApprovers;
